import classNames from "classnames"
import { useInputGroupContext } from "./InputGroupContext"
import { InputGroupAdornmentProps } from "./types"

export function InputGroupAdornment({ children, className }: InputGroupAdornmentProps) {
  const { size } = useInputGroupContext()
  const isMD = size === "md"
  const isSM = size === "sm"
  const _className = classNames(
    "flex items-center border-2 first:border-r-0 last:border-l-0 border-gray-300 bg-gray-100 first:rounded-tl-lg first:rounded-bl-lg  last:rounded-tr-lg last:rounded-br-lg self-stretch",
    { "px-3": isMD, "px-2": isSM },
    className,
  )
  return (
    <div className={_className}>
      <span>{children}</span>
    </div>
  )
}
